import { render, staticRenderFns } from "./invitationRanking.vue?vue&type=template&id=31de53fd&scoped=true&"
import script from "./invitationRanking.vue?vue&type=script&lang=js&"
export * from "./invitationRanking.vue?vue&type=script&lang=js&"
import style0 from "./invitationRanking.vue?vue&type=style&index=0&id=31de53fd&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de53fd",
  null
  
)

export default component.exports